import { capitalize } from 'lodash';

import {
  ActivityChangeOptions,
  DeltaText,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

import { RolloutData, RolloutSchedule, ScheduleStateReason } from '../../types';

const getScheduleStateText = (
  state: RolloutSchedule['state'] | undefined,
  reason?: ScheduleStateReason,
): string => {
  if (!state) return 'Not configured';

  if (state === 'FAILED') {
    return reason?.failed ? `Failed: ${reason.failed}` : 'Failed';
  }

  return capitalize(state);
};

const ScheduleChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as RolloutData | null;
  const newValue = change.newValue as RolloutData | null;

  const oldSchedule = oldValue?.schedule;
  const newSchedule = newValue?.schedule;

  const oldText = getScheduleStateText(
    oldSchedule?.state,
    oldSchedule?.stateReason,
  );
  const newText = getScheduleStateText(
    newSchedule?.state,
    newSchedule?.stateReason,
  );

  return <DeltaText oldText={oldText} newText={newText} disableDiff />;
};

export const SCHEDULE_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'rollout-schedule-change',
  predicate: ({ change }) => {
    if (change.fieldPath !== '/module_data/rollout') {
      return false;
    }
    const oldValue = change.oldValue as RolloutData | null;
    const newValue = change.newValue as RolloutData | null;
    const oldSchedule = oldValue?.schedule;
    const newSchedule = newValue?.schedule;

    // Only check if schedule state changed
    return oldSchedule?.state !== newSchedule?.state;
  },
  render: ScheduleChangeRender,
});
